import { useState, useEffect } from 'react';

function useOrientationDetector() {
  const [isLandscape, setIsLandscape] = useState(
    () => window.matchMedia('(orientation: landscape)').matches
  );

  useEffect(() => {
    const mq = window.matchMedia('(orientation: landscape)');
    let debounceTimer;
    let cooldownTimer;
    let locked = false;

    const handleChange = () => {
      if (locked) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const next = mq.matches;
        setIsLandscape(prev => (prev === next ? prev : next));
        // Lock out further events for 500ms so a layout shift caused by the
        // re-render cannot immediately bounce the orientation back.
        locked = true;
        clearTimeout(cooldownTimer);
        cooldownTimer = setTimeout(() => { locked = false; }, 500);
      }, 250);
    };

    mq.addEventListener('change', handleChange);
    return () => {
      mq.removeEventListener('change', handleChange);
      clearTimeout(debounceTimer);
      clearTimeout(cooldownTimer);
    };
  }, []);

  return isLandscape;
}

export default useOrientationDetector;
